import React, { useState, useCallback, useEffect, useContext, useMemo } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Select from 'react-select';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { calculateMRFromPress, formatToNewDataStructure } from './EstFunctions';
import UserContext from '../../Context/UserContext';
import { Input } from '../../utilities/Shared';

const PressSheetEstimator = ({ quoteInfo, setQuoteInfo }) => {
  const { papers, customers, employees, presses } = useContext(UserContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [forms, setForms] = useState([]);
  const [quote, setQuote] = useState(null);


const hasInitialized = React.useRef(false);
console.log(quoteInfo)
useEffect(() => {

  if (!quoteInfo?.forms || hasInitialized.current) return;

  const nums = quoteInfo.quantity
    ? quoteInfo.quantity.split(',').map(Number)
    : [];

  const minQty = nums.length ? Math.min(...nums) : 0;
  const maxQty = nums.length ? Math.max(...nums) : 0;

  const normalizedForms = quoteInfo.forms.map((form, index) => {
  const methodObj = methodOptions.find(
    m => m.label === form.method || m.value === form.method
  );

  return {
    id: form.id ?? `form-${index}`,
    ...form,
    method: methodObj || null,   // 👈 FIX HERE
    quantityMin: form.quantityMin ?? minQty,
    quantityMax: form.quantityMax ?? maxQty,
  };
});

  setForms(normalizedForms);

  hasInitialized.current = true;
}, [quoteInfo]);

useEffect(() => {
  if (!quoteInfo?.quantity) return;

  const nums = quoteInfo.quantity
    .split(',')
    .map(Number)
    .filter(n => !isNaN(n));

  const minQty = nums.length ? Math.min(...nums) : 0;
  const maxQty = nums.length ? Math.max(...nums) : 0;

  setForms(prev =>
    prev.map(form => ({
      ...form,
      quantityMin: minQty,
      quantityMax: maxQty
    }))
  );
}, [quoteInfo?.quantity]);





 
  const calculateForm = (quantity, form) => {
    const sheetArea = (form.flatLength || 0) * (form.flatWidth || 0);
    const pieceArea = (quoteInfo?.pflatl || 0) * (quoteInfo?.pflatw || 0);

    const up = form.numberUp || 1;
    const impressions = quantity / up;

    let cost = form.paper != undefined 
      ? (Number(quantity) * Number(form.paper?.paper.cwt)) / 100 
      : 0;

    const efficiency = pieceArea && sheetArea ? pieceArea / sheetArea : 0;

    return {
      impressions: Math.ceil(impressions),
      efficiency: Number(efficiency.toFixed(4)),
      waste: Number((1 - efficiency).toFixed(4)),
      cost: cost
    };
  };

  // Update form field
  const updateForm = useCallback((idx, field, value) => {
    setForms(prev =>
      prev.map((item, index) =>
        index === idx ? { ...item, [field]: value } : item
      )
    );
  }, []);

  // Calculate low/high for each form
  const calculatedForms = useMemo(() => {
  return forms.map((form) => {

    console.log(form)
    const mr = calculateMRFromPress(form.press, form.method,form.binks, form.finks);

    const min = Number(form.quantityMin) || 0;
    const max = Number(form.quantityMax) || 0;

    const low = calculateForm(min, form);
    const high = calculateForm(max, form);
    const base = calculateForm(mr, form);

    return {
      ...form,
      mr, // computed here
      calculations: { base, low, high }
    };
  });
}, [forms, quoteInfo?.quantity]);
//   const calculatedForms = useMemo(() => {
//     return forms.map((form) => {
//       const min = Number(form.quantityMin) || 0;
//       const max = Number(form.quantityMax) || 0;
// const mr = Number(form.mr) || 0;

//       const low = calculateForm(min, form);
//       const high = calculateForm(max, form);
// const base = calculateForm(mr, form);
//       return {
//         ...form,
//         calculations: {
//           base,
//           low,
//           high
//         }
//       };
//     });
//   }, [forms,quoteInfo?.quantity]);

const paperOptions = papers?.map(p => ({
  value: p.stockid,
  label: p.name,
  description: `${p.stockid || ''} • ${p.category || ''}`,
  paper: p
})) || [];

 const pressOptions = presses?.map(p => ({
  value: p.id || p.name || p.pressId,
  label:
    p.id === '5' || p.id === '6'
      ? `${p.pname} ${p.description}`
      : p.pname,
  description: p.description || '',
  pressData: p
})) || [];

const methodOptions = [
  { value: 'Sheetwise', label: 'Sheetwise' },
  { value: 'Work & Turn', label: 'Work & Turn' },
  { value: 'Work & Tumble', label: 'Work & Tumble' },
  { value: 'One-Sided', label: 'One-Sided' },
  { value: 'Perfect', label: 'Perfect' },
];


  console.log(forms)
  // Empty state
  if (!forms?.length) {
    return (
      <div className="mx-auto p-6 bg-white rounded-2xl shadow-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-teal-700">Press Sheet Estimator</h2>
          <button className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-xl font-medium transition">
            + Add New Form
          </button>
        </div>
        <div className="text-center py-12 text-gray-500">
          No forms loaded. Click "Add New Form" to start.
        </div>
      </div>
    );
  }

  console.log(calculatedForms);

  return (
    <div className="mx-auto p-6 bg-white rounded-2xl shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-teal-700">Press Sheet Estimator</h2>
        <button className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-xl font-medium transition">
          + Add New Form
        </button>
      </div>

      <Tabs selectedIndex={activeIndex} onSelect={setActiveIndex}>
        <TabList className="flex border-b border-gray-200 mb-6 overflow-x-auto" style={{ borderBottom: '1px solid #0F766E' }}>
          {calculatedForms.map((form, idx) => (
            <Tab
              key={form.id || `form-${idx}`}
              className="px-6 py-3 text-lg font-medium cursor-pointer border-b-4 border-transparent hover:border-teal-300 data-[selected]:border-teal-600 data-[selected]:text-teal-700 outline-none"
            >
              {form.componentName || `Form ${idx + 1}`}
            </Tab>
          ))}
        </TabList>

        {calculatedForms.map((form, idx) => (
          <TabPanel key={form.id || `form-${idx}`}>
            <div className="bg-gray-50 rounded-2xl p-6">

              {/* FORM NAME + PAPER */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8" style={{ alignItems: 'center' }}>
                <button className="mt-6 px-5 py-3 bg-teal-50 hover:bg-teal-100 text-teal-700 border border-teal-200 rounded-xl font-medium transition flex items-center gap-2 whitespace-nowrap">
                  📋 Duplicate
                </button>

                <div className="flex-3">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">Form Name</label>
                  <Input
                    type="text"
                    value={form.componentName || ''}
                    onChange={(e) => updateForm(idx, 'componentName', e.target.value)}
                  />
                </div>

  {/* Quantity Min */}
                <div className="flex-1">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">
                    Quantity 1 (Min)
                  </label>
                  <Input
                    type="number"
                    value={form.quantityMin || ''}
                    onChange={(e) =>
                      updateForm(idx, 'quantityMin', parseInt(e.target.value) || 0)
                    }
                  />
                </div>

                {/* Quantity Max */}
                <div className="flex-1">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">
                    Quantity 2 (Max)
                  </label>
                  <Input
                    type="number"
                    value={form.quantityMax || ''}
                    onChange={(e) =>
                      updateForm(idx, 'quantityMax', parseInt(e.target.value) || 0)
                    }
                  />
                </div>

 <div className="flex-1">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">
                   Versions
                  </label>
                  <Input
                    type="number"
                    value={form.versions || ''}
                    onChange={(e) =>
                      updateForm(idx, 'versions', parseInt(e.target.value) || 0)
                    }
                  />
                </div>
 <div className="flex-1">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">
                    Pages
                  </label>
                  <Input
                    type="number"
                    value={form.pages || ''}
                    onChange={(e) =>
                      updateForm(idx, 'pages', parseInt(e.target.value) || 0)
                    }
                  />
                </div>
 <div className="flex-1">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">
                    Forms
                  </label>
                  <Input
                    type="number"
                    value={form.numforms || ''}
                    onChange={(e) =>
                      updateForm(idx, 'numforms', parseInt(e.target.value) || 0)
                    }
                  />
                </div>
               
              </div>


 <div className="flex flex-col sm:flex-row gap-4 mb-8" style={{ alignItems: 'center' }}>
           <div className="flex-2">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">Press</label>
                  <Select
                    styles={{
    control: (base, state) => ({
      ...base,
      padding: "2px 4px",
      //borderLeft: "10px solid rgba(122, 187, 67, .5)",
      borderLeft: !form.press ? "10px solid rgba(255, 0, 0, .5)" : "10px solid rgba(122, 187, 67, .5)",
      boxShadow: !form.press ? '0 0 0 1px red' : state.isFocused ? base.boxShadow : undefined,
      borderColor: !form.press ? 'red' : base.borderColor,
      
    })
  }}
                    options={pressOptions}
                  value={form.press || null}
                 onChange={(selectedOption) => {
  updateForm(idx, 'press', selectedOption || null);
}}
                    getOptionLabel={(opt) => opt.label}
                    getOptionValue={(opt) => opt.value}
                    isClearable
                    placeholder="Select press..."
                  />
                </div>
                                      <div className="flex-2">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">Method</label>
          <Select
        styles={{
    control: (base, state) => ({
      ...base,
      padding: "2px 4px",
      borderLeft: "10px solid rgba(122, 187, 67, .5)",
    })
  }}
  options={methodOptions}
  value={form.method || null}   // ✅ FIXED
  onChange={(selectedOption) => {
    updateForm(idx, 'method', selectedOption || null);  // ✅ FIXED
  }}
  getOptionLabel={(opt) => opt.label}
  getOptionValue={(opt) => opt.value}
  isClearable
  placeholder="Select method..."   // optional rename
/>
                </div>
               <div className="flex-4">
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">Paper / Stock</label>
      <Select
       styles={{
    control: (base, state) => ({
      ...base,
      padding: "2px 4px",
   borderLeft: !form.paper ? "10px solid rgba(255, 0, 0, .5)" : "10px solid rgba(122, 187, 67, .5)",
      boxShadow: !form.paper ? '0 0 0 1px red' : state.isFocused ? base.boxShadow : undefined,
      borderColor: !form.paper ? 'red' : base.borderColor,
    })
  }}
  options={paperOptions}
  value={form.paper || null}
  onChange={(selectedOption) => {
    updateForm(idx, 'paper', selectedOption || null);
  }}
  isSearchable
filterOption={(option, inputValue) => {
  const search = inputValue.toLowerCase();

  return (
    option.label.toLowerCase().includes(search) ||
    option.description?.toLowerCase().includes(search) ||
    String(option.value).includes(search) // 👈 correct stockid search
  );
}}
  isClearable
  placeholder="Select paper..."
  formatOptionLabel={(option, { context }) => {
    if (context === 'menu') {
      return (
        <div style={{ lineHeight: '1.2' }}>
          <div style={{ fontWeight: 600 }}>
            {option.label}
          </div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>
            {option.description}s
          </div>
        </div>
      );
    }

    // Selected value (collapsed)
    return option.label;
  }}
/>


                </div>
      <div className="flex-[.7]">
        
                  <label className="block text-md text-lg font-medium text-gray-700 mb-1">Stock ID</label>
               <Input
               style={{borderLeft: !form.press ? "10px solid rgba(255, 0, 0, .5)" : "10px solid rgba(122, 187, 67, .5)",
      boxShadow: !form.paper?.value ? 'rgba(255, 0, 0, .5)' : 'inherit',
      borderColor: !form.paper?.value ? 'rgba(255, 0, 0, .5)' : 'inherit',}}
  value={form.paper?.value || ''}   // stockid is stored in value
  readOnly
   placeholder="Stock ID"
/>
                </div>
                </div>

              {/* PRESS + QUANTITIES */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8" style={{ alignItems: 'center' }}>
                   
                    <div className="flex-1">
                       <label className="block text-md text-lg font-medium text-gray-700 mb-1">Piece Size</label>
                              <Input
  style={{
    marginRight:'20px',
    borderLeft: !form.flatLength 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.flatLength 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.flatLength ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'flatLength', parseFloat(e.target.value) || 0)}
   placeholder="Piece Length"
/>
                    <Input
  style={{
    borderLeft: !form.flatWidth 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.flatWidth 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.flatWidth ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'flatWidth', parseFloat(e.target.value) || 0)}
   placeholder="Piece Width"
/>
                    </div>
                 

                  <div className="flex-1">
                    <label className="block text-md text-lg font-medium text-gray-700 mb-1">Press Sheet</label>
                    <div >
                       <Input
  style={{
    marginRight:'20px',
    borderLeft: !form.pressLength 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.pressLength 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.pressLength ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'pressLength', parseFloat(e.target.value) || 0)}
   placeholder="Press Length"
/>
                    <Input
  style={{
    borderLeft: !form.pressWidth 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.pressWidth 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.pressWidth ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'pressWidth', parseFloat(e.target.value) || 0)}
   placeholder="Press Width"
/>
                    </div>
                  </div>

                  <div className="flex-1">
                    <label className="block text-md text-lg font-medium text-gray-700 mb-1">Parent Sheet</label>
                    <div >
                      <Input
  style={{
    marginRight:'20px',
    borderLeft: !form.parentLength 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.parentLength 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.parentLength ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'parentLength', parseFloat(e.target.value) || null)}
  placeholder="Parent Length"
/>
                    <Input
  style={{
    borderLeft: !form.parentWidth 
      ? "10px solid rgba(255, 0, 0, 0.5)" 
      : "10px solid rgba(122, 187, 67, 0.5)",
    
    boxShadow: !form.parentWidth 
      ? "0 0 8px rgba(255, 0, 0, 0.6)" 
      : "0 0 8px rgba(0, 0, 0, 0.2)",
    
    // Remove borderColor - it's conflicting with borderLeft
  }}
  width="46%"
  type="number"
  value={form.parentWidth ?? ''}           // better than || ''
  onChange={(e) => updateForm(idx, 'parentWidth', parseFloat(e.target.value) || null)}
   placeholder="Parent Width"
/>
                    </div>
                  </div>

                {/* Press Select - Fixed */}
         
              </div>

              {/* SIZES */}
              <div className="mb-10">
               

           

                <div className="mt-6 grid grid-cols-1 md:grid-cols-5 gap-6">
                   <Input
                    type="number"
                    value={form.mr || ''}
                    onChange={(e) => updateForm(idx, 'mr', parseInt(e.target.value) || 0)}
                    placeholder="Make Ready"
                  />
                  <Input
                    type="number"
                    value={form.numberUp || ''}
                    onChange={(e) => updateForm(idx, 'numberUp', parseInt(e.target.value) || 0)}
                    placeholder="Number Up"
                  />
                  <Input
                    type="number"
                    value={form.additionalMR || ''}
                    onChange={(e) => updateForm(idx, 'additionalMR', parseInt(e.target.value) || 0)}
                    placeholder="Additional M/R"
                  />
                  <Input
                    type="number"
                    value={form.numberOutOfParent || ''}
                    onChange={(e) => updateForm(idx, 'numberOutOfParent', parseInt(e.target.value) || 0)}
                    placeholder="Out of Parent"
                  />
                </div>
              </div>

              {/* LOW / HIGH */}
              <div className="mt-6 p-4 bg-white border rounded-xl">
                <div className="text-xl text-gray-600 mb-2">
                  Lowest Qty: {form.quantityMin} | Highest Qty: {form.quantityMax}
                </div>

                <div className="grid grid-cols-3 gap-4 text-xs">
                       <div>
                    <div className="font-semibold text-teal-600">BASE</div>
                    <pre className='text-xl'>{JSON.stringify(form.calculations.base, null, 2)}</pre>
                  </div>
                  <div>
                    <div className="font-semibold text-teal-600">LOW</div>
                    <pre className='text-xl'>{JSON.stringify(form.calculations.low, null, 2)}</pre>
                  </div>
                  <div>
                    <div className="font-semibold text-purple-600">HIGH</div>
                    <pre className='text-xl'>{JSON.stringify(form.calculations.high, null, 2)}</pre>
                  </div>
                </div>
              </div>

              {forms.length > 1 && (
                <button className="mt-10 text-red-600 hover:text-red-700 font-medium">
                  🗑️ Delete this form
                </button>
              )}

            </div>
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default PressSheetEstimator;